import { Vue, Component, Prop, Emit, Watch } from "@wagich/vue-facing-decorator-metadata";
import { h } from "vue";

import { render } from "./main-navigation.html";

interface TabItem {
	id: string;
	name: string;
	icon: string | null;
	fragment: HTMLElement | null;
}

@Component({
	render,
	components: {
		Fragment: {
			props: ["fragment"],
			mounted() {
				this.$el.replaceWith(this.fragment);
			},
			render() {
				return h("div");
			}
		}
	},
})
export class MainNavigation extends Vue {
	tabs: TabItem[] = [];
	tabContents: string = "";
	activeTab: number | null = null;

	async mounted() {
		const dataElement = document.getElementById("main-navigation-data");
		if (!dataElement) {
			return;
		}
		this.tabs = JSON.parse(dataElement.textContent || "[]");
		for (let tab of this.tabs) {
			const element = document.querySelector<HTMLElement>(`#menucontent-${tab.id}`);
			if (!element) {
				continue;
			}
			element.remove();
			tab.fragment = element;
		}
		document.querySelector(".main-nav")?.remove();
		await this.$nextTick();
		this.activeTab = this.tabs.length > 0 ? 0 : null;
	}
}
